import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52598fe8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = { class: "d-flex justify-space-between w-100 controls" }
const _hoisted_3 = { class: "step1 mb-9" }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "border rounded-lg card-step pa-4 mt-12" }
const _hoisted_6 = { class: "d-flex justify-space-between" }
const _hoisted_7 = { class: "text-value" }
const _hoisted_8 = { class: "text-value" }
const _hoisted_9 = {
  key: 0,
  class: "d-flex justify-space-between"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "text-value" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "text-value" }
const _hoisted_14 = { class: "d-flex justify-space-between" }
const _hoisted_15 = { class: "text-value" }
const _hoisted_16 = {
  key: 1,
  class: "d-flex justify-space-between"
}
const _hoisted_17 = { class: "text-value" }
const _hoisted_18 = {
  key: 2,
  class: "d-flex justify-space-between"
}
const _hoisted_19 = { class: "text-value" }
const _hoisted_20 = {
  key: 3,
  class: "d-flex justify-space-between"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "text-value" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "text-value" }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { class: "text-value" }

import { withDefaults, ref, computed } from 'vue';
import { AtomButton, BtnChevronLeft, BtnChevronRight } from '@/components/atoms';
import StepActiveIcon from './icons/StepActiveIcon.vue';
import { IStep } from '@/types';
import CompletedStepIcon from './icons/CompletedStepIcon.vue';

interface IProps {
  steps: any[];
  currentStep: string;
  isLarge?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AtomProgressSaltos',
  props: {
    steps: {},
    currentStep: {},
    isLarge: { type: Boolean, default: false }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "ea4eaae2": (steps.value),
  "999a587e": (fontsize_title.value),
  "62053c76": (sizeIconCheck.value),
  "9a7d8b6e": (linetop.value),
  "7bd199cd": (width_cardstep.value),
  "95ed5566": (fontsize_textvalue.value)
}))

const props = __props;
const steps = ref(props.steps.length);
const areaSaltos = ref<HTMLElement>();

const fontsize_title = computed(() => {
  return props.isLarge ? '24px' : '14px';
});
const widtharea = computed(() => {
  return props.isLarge ? '245px' : '145px';
});
const width_cardstep = computed(() => {
  return props.isLarge ? '230px' : '130px';
});
const fontsize_textvalue = computed(() => {
  return props.isLarge ? '26px' : '18px';
});
const sizeIconCheck = computed(() => {
  return props.isLarge ? '44px' : '24px';
});
const linetop = computed(() => {
  return props.isLarge ? '53px' : '43px';
});
function handleRight() {
  if (areaSaltos.value) {
    const nvalue = props.isLarge ? 245 : 135
    areaSaltos.value.scrollBy({
      left: nvalue,
      behavior: 'smooth',
    });
  }
}
function handleLeft() {
  if (areaSaltos.value) {
    const nvalue = props.isLarge ? -245 : -135
    areaSaltos.value.scrollBy({
      left: nvalue,
      behavior: 'smooth',
    });
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(AtomButton), {
        background: "transparent",
        class: "pa-0",
        onMousedown: handleLeft
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BtnChevronLeft))
        ]),
        _: 1
      }),
      _createVNode(_unref(AtomButton), {
        background: "transparent",
        class: "pa-0",
        onMousedown: handleRight
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(BtnChevronRight))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", {
      ref_key: "areaSaltos",
      ref: areaSaltos,
      class: "area"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.steps, (step, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: String(step.label),
          class: "d-flex flex-column align-center relative",
          style: _normalizeStyle(`flex-shrink: 0; width: ${widtharea.value}`)
        }, [
          _createElementVNode("p", {
            style: _normalizeStyle({ color: _ctx.currentStep === step.label ? '#212529' : '' }),
            class: "title-step"
          }, _toDisplayString(step.label), 5),
          _createElementVNode("div", _hoisted_3, [
            (step.completed)
              ? (_openBlock(), _createBlock(CompletedStepIcon, { key: 0 }))
              : (_ctx.currentStep === step.label)
                ? (_openBlock(), _createBlock(StepActiveIcon, { key: 1 }))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(index + 1), 1))
          ]),
          _createElementVNode("div", {
            style: _normalizeStyle({ background: _ctx.currentStep === step.label || step.completed ? '#FFDECC' : '' }),
            class: "line-step-l"
          }, null, 4),
          _createElementVNode("div", {
            style: _normalizeStyle({ background: step.completed ? '#FFDECC' : '' }),
            class: "line-step-r"
          }, null, 4),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", null, [
                _createElementVNode("p", {
                  class: _normalizeClass(["text-muted", { 'text-xs': !props.isLarge }])
                }, "Latência", 2),
                _createElementVNode("p", _hoisted_7, _toDisplayString(step.latencia), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("p", {
                  class: _normalizeClass(["text-muted", { 'text-xs': !props.isLarge }])
                }, "Jitter", 2),
                _createElementVNode("p", _hoisted_8, _toDisplayString(step.jitter), 1)
              ])
            ]),
            (step.maxJitter || step.bestLatency)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (step.maxJitter)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("p", {
                          class: _normalizeClass(["text-muted", { 'text-xs': !props.isLarge }])
                        }, "Maior Jitter", 2),
                        _createElementVNode("p", _hoisted_11, _toDisplayString(step.maxJitter), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (step.bestLatency)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("p", {
                          class: _normalizeClass(["text-muted", { 'text-xs': !props.isLarge }])
                        }, "Melhor Latência", 2),
                        _createElementVNode("p", _hoisted_13, _toDisplayString(step.bestLatency), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", null, [
                _createElementVNode("p", {
                  class: _normalizeClass(["text-muted", { 'text-xs': !props.isLarge }])
                }, "Perda de pacote", 2),
                _createElementVNode("p", _hoisted_15, _toDisplayString(step.perda), 1)
              ])
            ]),
            (step.host)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", {
                      class: _normalizeClass(["text-muted", { 'text-xs': !props.isLarge }])
                    }, "Host", 2),
                    _createElementVNode("p", _hoisted_17, _toDisplayString(step.host), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (step.ipLocation)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", {
                      class: _normalizeClass(["text-muted", { 'text-xs': !props.isLarge }])
                    }, "Localização IP", 2),
                    _createElementVNode("p", _hoisted_19, _toDisplayString(step.ipLocation), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (step.location || step.unitLongitude || step.unitLatitude)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  (step.location)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("p", {
                          class: _normalizeClass(["text-muted", { 'text-xs': !props.isLarge }])
                        }, "Localização", 2),
                        _createElementVNode("p", _hoisted_22, _toDisplayString(step.location), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (step.unitLatitude)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createElementVNode("p", {
                          class: _normalizeClass(["text-muted", { 'text-xs': !props.isLarge }])
                        }, "Latitude", 2),
                        _createElementVNode("p", _hoisted_24, _toDisplayString(step.unitLatitude), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (step.unitLongitude)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("p", {
                          class: _normalizeClass(["text-muted", { 'text-xs': !props.isLarge }])
                        }, "Longitude", 2),
                        _createElementVNode("p", _hoisted_26, _toDisplayString(step.unitLongitude), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ], 4))
      }), 128))
    ], 512)
  ]))
}
}

})